import { t } from '@exam-prep/i18n';

/** Brand strip at the top of the hub: badge logo, wordmark and the logo's tagline. */
export function BrandBar() {
  return (
    <div className="flex items-center gap-3 px-4 pt-4">
      <picture>
        <source srcSet="/brand/logo-64.webp 1x, /brand/logo-128.webp 2x" type="image/webp" />
        <img
          src="/brand/logo-192.png"
          alt=""
          width={44}
          height={44}
          className="brand-halo size-11"
        />
      </picture>
      <div className="min-w-0">
        <p className="font-display text-lg leading-tight font-bold">SSCExamPrep</p>
        <p className="text-[11px] tracking-[0.18em] text-muted-foreground uppercase">
          {t('miniapp.brand.tagline')}
        </p>
      </div>
    </div>
  );
}
